/* eslint-env browser */

const DomHelper = require('../../client/clientjs/dom-helper')

class FilterControl {
  constructor(opts) {
    this.allBusinessTypes = opts.allBusinessTypes || []
    this.selected = opts.selected
    this.onSelectionChanged = opts.onSelectionChanged
  }

  onAdd(map) {
    this.map = map
    this.container = document.createElement('div')

    this.container.className = 'mapboxgl-ctrl-filter'
    this.container.innerHTML = `
      <div class="mapboxgl-ctrl mapboxgl-ctrl-group">
        <button id="filters-button" class="mapboxgl-ctrl"><h4 class="h5">Filtres&nbsp;<i class="fa fa-list"></i></h4></button>
      </div>
      <div class="mapboxgl-ctrl mapboxgl-ctrl-group list">
        ${this.allBusinessTypes
          .map(
            businessType => `
          <button class="mapboxgl-ctrl btn-select-businessType ${
            this.selected[businessType.id] ? 'selected' : ''
          }" id="btn-${businessType.id}" data-business-type-id="${businessType.id}">
            <div class="inner-container">
              <img src="${businessType.iconUrl}" height="30" width="30"></img>
              <span class="name">${businessType.name}</span>
              <input id="checkbox-${businessType.id}" type="checkbox" ${
              this.selected[businessType.id] ? 'checked' : ''
            }/>
            </div>
          </button>
          `
          )
          .join('')}
      </div>`

    this.allBusinessTypes.forEach(businessType => {
      const button = this.container.querySelector(`#btn-${businessType.id}`)
      const checkbox = button.querySelector('input[type=checkbox]')
      button.onclick = () => {
        this.selected[businessType.id] = !this.selected[businessType.id]
        checkbox.checked = this.selected[businessType.id]
        if (this.selected[businessType.id]) {
          DomHelper.addClass(button, 'selected')
        } else {
          DomHelper.removeClass(button, 'selected')
        }
        this.onSelectionChanged(this.selected)
      }
    })

    this.container.querySelector('#filters-button').onclick = () => {
      DomHelper.toggleClass(this.container.querySelector('.list'), 'visible')
    }

    return this.container
  }

  onRemove() {
    this.container.parentNode.removeChild(this.container)
    this.map = undefined
  }
}

module.exports = FilterControl
